'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.endTask = exports.beginTask = exports.NProgress = exports.nprogress = exports.nprogressMiddleware = undefined;

var _middleware = require('./middleware');

var _middleware2 = _interopRequireDefault(_middleware);

var _reducer = require('./reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _NProgressComponent = require('./NProgressComponent');

var _NProgressComponent2 = _interopRequireDefault(_NProgressComponent);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.nprogressMiddleware = _middleware2.default;
exports.nprogress = _reducer2.default;
exports.NProgress = _NProgressComponent2.default;
exports.beginTask = _actions.beginTask;
exports.endTask = _actions.endTask;


//////////////////
// WEBPACK FOOTER
// ./~/redux-nprogress/lib/index.js
// module id = 163
// module chunks = 2